import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PageHeader from '../../header';
import { useDispatch, useSelector } from 'react-redux';
import BottomLogo from 'components/shared/bottom-logo/content.js';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel, { BottomSession } from './rightPanelOrTopPanel';
import OrgSettingMenu from './orgSettingMenu';
import WASettingMenu from './waSettingMenu';
import MRSettingMenu from './mrSettingMenu';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import OrganisationalUnitLogoImagePage from '../../../../containers/OrganisationalUnitLogoImagePage';
import CreateWaitingAreaPage from '../../../../containers/CreateWaitingAreaPage';
import CreateMeetingRoomPage from '../../../../containers/CreateMeetingRoomPage';
import OrgUnitGeneralInfoModal from '../../org-unit/general-info/content';
import OrgUnitSupportContactModal from '../../org-unit/support-contact/content';
import OrgUnitBeforeCallsWAModal from '../../org-unit/before-calls-wa/content';
import OrgUnitShareLinkWAModal from '../../org-unit/share-link-wa/content';
import OURecordingSettingModal from '../../org-unit/recording/content';
import OrgUnitCreateModal from '../createOU/content';
import CreateOUButton from './CreateOUButton';
import DefaultGroupConsultationSettingsContent from '../default-gc-settings/content';
import DeleteOrganizationModal from '../delete-organization/content';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import WaitingAreasAdminModalsContainer from '../../../../containers/WaitingAreasModalsContainer';
import MeetingRoomsAdminModalsContainer from '../../../../containers/MeetingRoomModalsContainer';
import {
  updateIsOnEntityListingPage,
  resetEntitySearchForm,
  updateOrgUnitSearch,
  updateFilterValue,
} from 'actions/organisation';
import { previousPage } from 'actions/navigationBar';
import { getInitialFilterValueByRoles } from './entityRowMarkup';

export const filterOptions = [
  { key: 1, text: 'Show All', value: 1 },
  { key: 2, text: 'Waiting Areas', value: 2 },
  { key: 3, text: 'Meeting Rooms', value: 3 },
];

export const filterShortTextOptions = [
  { text: 'Show All', value: 1 },
  { text: 'Waiting Areas', value: 2 },
  { text: 'Meeting Rooms', value: 3 },
];

export const tableHeaderColour = {
  1: {
    background: 'color-organisational-unit-bg',
    highlight: 'color-organisational-unit-bg-highlight',
  },
  2: {
    background: 'color-waiting-area-bg',
    highlight: 'color-waiting-area-bg-highlight',
  },
  3: {
    background: 'color-meeting-room-bg',
    highlight: 'color-meeting-room-bg-highlight',
  },
};

export const SettingMenuContext = React.createContext(null);

const EntityAdminContent = (props) => {
  // Search filter & submission
  const [filterValue, setFilterValue] = useState(
    getInitialFilterValueByRoles(props.entityAdminRights, props.previousPage, props.storedFilterValue)
  ); // Entity type filter value: 3 == MR, 2 == WA, 1 == Org
  const [searchTermSubmitted, setSearchTermSubmitted] = useState(''); // Search is submitted or not
  const [fetchingOrgs, setFetchingOrgs] = useState(false);
  const [fetchingRHSStats, setFetchingRHSStats] = useState(false);
  const [isOnMobileOrTablet, setIsOnMobileOrTablet] = useState(
    window.innerWidth < window.styleVariable.computerMinWidth
  );
  // Entity setting menu in RHS
  const [openMRSettingMenu, setOpenMRSettingMenu] = useState(false); // WA setting menu open or not
  const [openWASettingMenu, setOpenWASettingMenu] = useState(false); // WA setting menu open or not
  const [openOrgSettingMenu, setOpenOrgSettingMenu] = useState(false); // Org setting menu open or not
  const [settingSubMenuActiveIndex, setSettingSubMenuActiveIndex] = useState(-1); // Setting menu submenu open or not
  // Tree view
  const [treeViewActiveIndex, setTreeViewActiveIndex] = useState([]); // First level tree view open or not
  // Entity Selection
  const [highlightOrgUnits, setHighlightSelectedOrgUnits] = useState([]); // the org unit row that is highlighted
  const [highlightWaitingAreas, setHighlightWaitingAreas] = useState([]); // the waiting area row that is highlighted
  const [highlightMeetingRooms, setHighlightMeetingRooms] = useState([]); // the waiting area row that is highlighted

  //GC setting for Chat and FullName controls
  const isChatFeatureEnabled = useSelector((state) => state.usersReducer.userProfile.isChatFeatrueEnabled);
  const isFullNameFeatureEnabled = useSelector((state) => state.usersReducer.userProfile.isFullNameFeatureEnabled);
  const showGCSettingsModal = useSelector((state) => state.modalReducer.showGCSettingsModal);

  const [newSearchIndicator, setNewSearchIndicator] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateIsOnEntityListingPage(true));
    dispatch(previousPage(window.APP.LANGUAGE.ViewAllOrgUnit.Title));
    dispatch(updateFilterValue(1));
    return () => {
      dispatch(updateIsOnEntityListingPage(false));
      setOpenOrgSettingMenu(false);
      dispatch(updateOrgUnitSearch(''));
      dispatch(resetEntitySearchForm());
    };
  }, []);
  useEffect(() => {
    window.addEventListener('resize', (event) =>
      setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
    );

    return () => {
      window.removeEventListener('resize', (event) =>
        setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
      );
    };
  }, []);

  // For fixing RHS when fetching new data
  useEffect(() => {
    if (fetchingOrgs && props.entitySearchForm.currentActivePageNo === 0) {
      setFetchingRHSStats(true);
    } else {
      setFetchingRHSStats(false);
    }
  }, [props.entitySearchForm, fetchingOrgs]);

  useEffect(() => {
    let availableFilterValues = [];
    // This includes service admin & mr admin
    // if (isServiceAdminOnly(props.entityAdminRights)) {
    //   availableFilterValues = [2];
    // } else if (isMRAdminOnly(props.entityAdminRights)) {
    //   availableFilterValues = [3];
    // } else if (isServiceAndMRAdminOnly(props.entityAdminRights)) {
    //   availableFilterValues = [2, 3];
    // } else {
    //   availableFilterValues = [1, 2, 3];
    // }

    // Exclude service admin & mr admin
    availableFilterValues = [1, 2, 3];

    // If current filter value is not in availableFilterValues, reset the filter value to default
    if (availableFilterValues.indexOf(filterValue) === -1) {
      setFilterValue(getInitialFilterValueByRoles(props.entityAdminRights));
    }
  }, [props.entityAdminRights]);

  const settingStore = {
    mrSetting: [openMRSettingMenu, setOpenMRSettingMenu],
    waSetting: [openWASettingMenu, setOpenWASettingMenu],
    orgSetting: [openOrgSettingMenu, setOpenOrgSettingMenu],
    searchBar: [searchTermSubmitted, setSearchTermSubmitted],
    fetchingIndicator: [fetchingOrgs, setFetchingOrgs],
    fetchingStatsIndicator: [fetchingRHSStats, setFetchingRHSStats],
    highlightOrgs: [highlightOrgUnits, setHighlightSelectedOrgUnits],
    highlightWAs: [highlightWaitingAreas, setHighlightWaitingAreas],
    highlightMRs: [highlightMeetingRooms, setHighlightMeetingRooms],
    openSubMenu: [settingSubMenuActiveIndex, setSettingSubMenuActiveIndex],
    openOrgTreeViewArray: [treeViewActiveIndex, setTreeViewActiveIndex],
    selectedOrgUnit: props.selectedOrgUnit,
    selectedWaitingArea: props.selectedWaitingArea,
    selectedMeetingRoom: props.selectedMeetingRoom,
    entityFilter: [filterValue, setFilterValue],
    searchIndicator: [newSearchIndicator, setNewSearchIndicator],
  };

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = settingSubMenuActiveIndex === index ? -1 : index;
    setSettingSubMenuActiveIndex(newIndex);
  };

  const closeMenu = () => {
    setOpenOrgSettingMenu(false);
    setOpenWASettingMenu(false);
    setOpenMRSettingMenu(false);
    setSettingSubMenuActiveIndex(-1);
  };

  let orgModals = '';
  let adminModals = (
    <div>
      {props.showCreateOUModal && props.entityAdminRights.isAdmin ? (
        <OrgUnitCreateModal
          changeFilterValue={(value) => {
            let oldFilterValue = filterValue;
            setFilterValue(value);
            if (oldFilterValue === value) {
              // if filterValue does not change, it won't trigger new search, need to trigger it here
              setNewSearchIndicator(newSearchIndicator + 1);
            }
          }}
        />
      ) : (
        ''
      )}
    </div>
  );
  if (props.selectedOrgUnit) {
    if (props.selectedOrgUnit && props.selectedOrgUnit.permissions && props.selectedOrgUnit.permissions.length > 0) {
      let hasEditOrgUnitAccess = props.selectedOrgUnit.permissions.indexOf('EDIT') > -1;

      orgModals = (
        <div>
          {props.showOrganisationalUnitLogoImageModal && hasEditOrgUnitAccess ? (
            <OrganisationalUnitLogoImagePage
              showOrganisationalUnitLogoImageModal={props.showOrganisationalUnitLogoImageModal}
              readOnly={false}
            />
          ) : (
            ''
          )}
          <CreateWaitingAreaPage
            changeFilterValue={(value) => {
              let oldFilterValue = filterValue;
              setFilterValue(value);
              if (oldFilterValue === value) {
                // if filterValue does not change, it won't trigger new search, need to trigger it here
                setNewSearchIndicator(newSearchIndicator + 1);
              }
            }}
            showCreateWaitingAreaModal={props.showCreateWaitingAreaModal}
          />
          <CreateMeetingRoomPage
            changeFilterValue={(value) => {
              let oldFilterValue = filterValue;
              setFilterValue(value);
              if (oldFilterValue === value) {
                // if filterValue does not change, it won't trigger new search, need to trigger it here
                setNewSearchIndicator(newSearchIndicator + 1);
              }
            }}
            showCreateMeetingRoomModal={props.showCreateMeetingRoomModal}
          />
          {props.showOrgUnitGeneralInfoModal && hasEditOrgUnitAccess ? (
            <OrgUnitGeneralInfoModal
              selectedOrgUnit={props.selectedOrgUnit}
              isOnMobileOrTablet={isOnMobileOrTablet}
              updateOrView="update"
            />
          ) : (
            ''
          )}
          {props.showOrgUnitSupportContactModal && hasEditOrgUnitAccess ? (
            <OrgUnitSupportContactModal
              selectedOrgUnit={props.selectedOrgUnit}
              isOnMobileOrTablet={isOnMobileOrTablet}
              updateOrView="update"
            />
          ) : (
            ''
          )}
          {props.showOrgUnitBeforeCallsWAModal && hasEditOrgUnitAccess ? (
            <OrgUnitBeforeCallsWAModal selectedOrgUnit={props.selectedOrgUnit} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showOrgUnitShareLinkWAModal && hasEditOrgUnitAccess ? (
            <OrgUnitShareLinkWAModal selectedOrgUnit={props.selectedOrgUnit} updateOrView="update" />
          ) : (
            ''
          )}
          {props.showOURecordingSettingModal ? (
            props.entityAdminRights.isAdmin && !props.isSystemAdmin ? (
              <OURecordingSettingModal
                orgUnit={props.selectedOrgUnit}
                updateOrView="update"
                showOURecordingModal={props.showOURecordingSettingModal}
                isAdmin={props.entityAdminRights.isAdmin}
                isRecordingEnabled={props.OURecordingFeature}
              />
            ) : (
              <OURecordingSettingModal
                orgUnit={props.selectedOrgUnit}
                updateOrView="view"
                showOURecordingModal={props.showOURecordingSettingModal}
                isAdmin={props.entityAdminRights.isAdmin}
                isRecordingEnabled={props.OURecordingFeature}
              />
            )
          ) : (
            ''
          )}
          {props.showOuDefaultGcSettingsModal ? (
            <DefaultGroupConsultationSettingsContent
              showOuDefaultGcSettingsModal={props.showOuDefaultGcSettingsModal}
              orgUnit={props.selectedOrgUnit}
              isGCSettingsEnabled={true}
              updateOrView={props.updateOrView}
              isAdmin={true}
              dispatch={props.dispatch}
            />
          ) : (
            ''
          )}
          {props.showDeleteOrganizationModal &&
          ((props.entityAdminRights.isAdmin && !props.entityAdminRights.isSystemAdmin) ||
            (props.entityAdminRights.isSystemAdmin && props.entityAdminRights.isSysAdminAllowedToDeleteOrg)) ? (
            <DeleteOrganizationModal
              meetingRoomsDeletionStatus={props.meetingRoomsDeletionStatus}
              waitingAreasDeletionStatus={props.waitingAreasDeletionStatus}
              organizationDeletionStatus={props.organizationDeletionStatus}
              dispatch={props.dispatch}
              selectedOrganization={props.selectedOrgUnit}
              cbAfterDeletion={() => setOpenOrgSettingMenu(false)}
            />
          ) : (
            ''
          )}
        </div>
      );
    }
  }

  return (
    <SettingMenuContext.Provider value={settingStore}>
      <div className="main-ui-container entity-admin-page waiting-area-view-one new-waiting-area-view-one">
        {!isOnMobileOrTablet ? (
          <Container fluid className="row">
            <div className="left-hand-side-panel">
              <div className="relative">
                <PageHeader
                  title={APP.LANGUAGE.EntityAdmin.Title}
                  titleColor="color-primary-dark-grey"
                  notRenderLogo={true}
                >
                  <span>
                    <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.OrgUnitsIcon.default} />
                  </span>
                </PageHeader>
                <CenterPanel
                  organisations={props.organisations}
                  isOnMobileOrTablet={false}
                  entityAdminRights={props.entityAdminRights}
                  entitySearchForm={props.entitySearchForm}
                  tableHeaderColour={tableHeaderColour}
                  closeMenu={closeMenu}
                />
              </div>
            </div>
            <div className="right-hand-side-panel color-right-hand-side-panel-bg">
              <RightPanelOrTopPanel
                userId={props.userId}
                isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
                isConsultNowFeatureEnabled={props.isConsultNowFeatureEnabled}
                entityAdminRights={props.entityAdminRights}
                entityStats={props.entityStats}
                closeMenu={() => {
                  closeMenu();
                  setHighlightSelectedOrgUnits([]);
                  setHighlightWaitingAreas([]);
                  setHighlightMeetingRooms([]);
                }}
                handleClick={handleClick}
                isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
                WAOURecordingEnable={props.selectedWaitingArea ? props.selectedWaitingArea.isRecordingEnabled : false}
                isFullNameFeatureEnabled={isFullNameFeatureEnabled}
                isChatFeatureEnabled={isChatFeatureEnabled}
              />
            </div>
          </Container>
        ) : (
          <Container fluid>
            <WASettingMenu
              isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
              isConsultNowFeatureEnabled={props.isConsultNowFeatureEnabled}
              entityAdminRights={props.entityAdminRights}
              handleClick={handleClick}
              closeMenu={closeMenu}
              isOnMobileOrTablet={true}
              isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
              WAOURecordingEnable={props.selectedWaitingArea ? props.selectedWaitingArea.isRecordingEnabled : false}
              isFullNameFeatureEnabled={isFullNameFeatureEnabled}
              isChatFeatureEnabled={isChatFeatureEnabled}
            />
            <MRSettingMenu
              entityAdminRights={props.entityAdminRights}
              handleClick={handleClick}
              closeMenu={closeMenu}
              isOnMobileOrTablet={true}
            />
            <OrgSettingMenu
              isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
              entityAdminRights={props.entityAdminRights}
              closeMenu={closeMenu}
              handleClick={handleClick}
              isOnMobileOrTablet={true}
              isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
              isFullNameFeatureEnabled={isFullNameFeatureEnabled}
              isChatFeatureEnabled={isChatFeatureEnabled}
            />
            <div className="left-hand-side-panel-mobile">
              <PageHeader
                title={APP.LANGUAGE.EntityAdmin.Title}
                titleColor="color-primary-dark-grey"
                notRenderLogo={true}
              >
                <span>
                  <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.OrgUnitsIcon.default} />
                </span>
              </PageHeader>
              <div className="pdbm pdrm pdlm">
                {props.entityStats ? (
                  <div className="pdrm">
                    {filterValue === 1 ? (
                      <div>
                        <span className="bold">{APP.LANGUAGE.EntityAdmin.OUStats}</span>
                        {fetchingRHSStats
                          ? ''
                          : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                              '##count##',
                              props.entityStats.matchedOUs
                            ).replace('##total##', props.entityStats.totalOURows)}
                      </div>
                    ) : (
                      ''
                    )}
                    {filterValue === 1 || filterValue === 2 ? (
                      <div>
                        <span className="bold">{APP.LANGUAGE.EntityAdmin.WAStats}</span>
                        {fetchingRHSStats
                          ? ''
                          : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                              '##count##',
                              props.entityStats.wasOfMatchedOUs
                            ).replace('##total##', props.entityStats.totalWAs)}
                      </div>
                    ) : (
                      ''
                    )}
                    {filterValue === 1 || filterValue === 3 ? (
                      <div>
                        <span className="bold">{APP.LANGUAGE.EntityAdmin.MRStats}</span>
                        {fetchingRHSStats
                          ? ''
                          : APP.LANGUAGE.EntityAdmin.CountOfTotal.replace(
                              '##count##',
                              props.entityStats.mrsOfMatchedOUs
                            ).replace('##total##', props.entityStats.totalMRs)}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="right-hand-side-panel-mobile">
                {props.entityAdminRights.isAdmin ? (
                  <div className="pdlm pdrm">
                    <CreateOUButton />
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div>
                <CenterPanel
                  organisations={props.organisations}
                  tableHeaderColour={tableHeaderColour}
                  entityAdminRights={props.entityAdminRights}
                  closeMenu={closeMenu}
                  entitySearchForm={props.entitySearchForm}
                  isOnMobileOrTablet={true}
                />
                <ScrollToTopButton className="scroll-top-btn-desktop" />
              </div>
              <div className="mrtl right-hand-side-bottom-on-mobile">
                <BottomSession userId={props.userId} />
                <BottomLogo />
              </div>
            </div>
          </Container>
        )}
        <Container fluid as={Media} lessThan="computer">
          <ScrollToTopButton className="scroll-top-btn-desktop" />
        </Container>
        {orgModals}
        {adminModals}
        <MeetingRoomsAdminModalsContainer
          meetingRoom={props.selectedMeetingRoom}
          cbAfterDeletion={() => setOpenMRSettingMenu(false)}
        />
        <WaitingAreasAdminModalsContainer
          waitingArea={props.selectedWaitingArea}
          orgUnit={props.selectedOrgUnit}
          cbAfterDeletion={() => setOpenWASettingMenu(false)}
        />
      </div>
    </SettingMenuContext.Provider>
  );
};

export default EntityAdminContent;
